import React from 'react';
import { Redirect, RouteProps, Route as RouteWrapper } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBoolean, getItem } from 'src/helpers/common/localStorage';
import { REACT_APP_AUTH, REACT_APP_USER } from 'src/utils/config';
import { UserType } from 'src/model/UserType';

interface RouteWrapperProps extends RouteProps {
  component: any;
  isPrivateRoute?: boolean;
  allowedTypes?: UserType[];
}

export const Route: React.FC<RouteWrapperProps> = ({
  component: Component,
  isPrivateRoute,
  allowedTypes,
  ...rest
}: RouteWrapperProps): JSX.Element => {
  const signed = getBoolean(String(REACT_APP_AUTH));
  if (isPrivateRoute && !signed) {
    toast.warn('Faça login novamente.');
    return <Redirect to="/login" />;
  }

  if (allowedTypes && allowedTypes.length > 0) {
    const user = getItem(String(REACT_APP_USER)) as { type?: UserType } | null;
    const hasAccess = !!user && !!user.type && allowedTypes.includes(user.type);
    if (!hasAccess) {
      toast.warn('Acesso negado.');
      return <Redirect to="/" />;
    }
  }

  return (
    <RouteWrapper {...rest} render={(props) => <Component {...props} />} />
  );
};
